import React, { useContext, useEffect, useState } from "react";
import SellerMasterLayout from "../../../layout/seller/SellerMasterLayout";
import { Container } from "react-bootstrap";
import {
  CheckCircle,
  Clock,
  XCircle,
  Package,
  Check,
  X,
  RefreshCw,
} from "lucide-react";
import "../../../assets/css/seller/OrdersInSeller/ordersInSeller.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";

/* ── Status Badge ── */
const StatusBadge = ({ status }) => {
 const map = {
  complete: {
    label: "Completed",
    cls: "tfp-badge--completed",
    icon: <CheckCircle size={13} />,
  },
  pending: {
    label: "Pending",
    cls: "tfp-badge--pending",
    icon: <Clock size={13} />,
  },
  cancelled: {
    label: "Cancelled",
    cls: "tfp-badge--cancelled",
    icon: <XCircle size={13} />,
  },
  ongoing: {
    label: "Ongoing",
    cls: "tfp-badge--ongoing",
    icon: <RefreshCw size={13} />,
  },
};
  const s = map[status] || map["pending"];
  return (
    <span className={`tfp-badge ${s.cls}`}>
      {s.icon} {s.label}
    </span>
  );
};

/* ── Filter Tabs Config ── */
const TABS = [
  { key: "all", label: "All" },
  { key: "ongoing", label: "Ongoing" },
  { key: "complete", label: "Completed" },
  { key: "cancelled", label: "Cancelled" },
  { key: "pending", label: "Pending" },
];

/* ── Main Component ── */
const OrdersInSeller = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("all");
  const [ordersData, setOrdersData] = useState([]);
  const [loadingCompleteId, setLoadingCompleteId] = useState(null);
  const [loadingCancelId, setLoadingCancelId] = useState(null);
  const [loadingOngoingId, setLoadingOngoingId] = useState(null);

  const { baseUrl, loggedInSeller } = useContext(AppContext);
  const seller = JSON.parse(localStorage.getItem("loggedInSeller") || "null");

  const viewOrders = () => {
    const sellerId = loggedInSeller?.id || seller?.id;
    if (!sellerId) return;

    const formData = new FormData();
    formData.append("tpshop_id", sellerId);
    console.log("Shop ID:", sellerId);

    axios
      .post(`${baseUrl}/seller/orders/viewOrders`, formData, {
        headers: { "Content-Type": "multipart/formData" },
      })
      .then((response) => {
        console.log("Orders:", response.data.orders);
        setOrdersData(response.data.orders);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    console.log("********* useEffect called in order page", loggedInSeller);
    viewOrders();
    console.log("Seller:", loggedInSeller);
    console.log("Shop ID:", loggedInSeller?.id);
  }, []);

  const filteredOrders =
    activeTab === "all"
      ? ordersData
      : ordersData.filter((o) => o.status === activeTab);

  /* Count per tab */
  const countOf = (key) =>
    key === "all"
      ? ordersData.length
      : ordersData.filter((o) => o.status === key).length;

  return (
    <SellerMasterLayout>
      <div className="tfp-orders-page">
        <Container>
          {/* Heading */}
          <h1 className="tfp-orders-heading">Orders</h1>
          <p className="tfp-orders-subheading">Manage all your orders</p>

          {/* Filter Tabs */}
          <div className="tfp-filter-tabs">
            {TABS.filter((t) => countOf(t.key) > 0 || t.key === "all").map(
              (tab) => (
                <button
                  key={tab.key}
                  className={`tfp-tab ${activeTab === tab.key ? "tfp-tab--active" : ""}`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label} ({countOf(tab.key)})
                </button>
              ),
            )}
          </div>

          {/* Table Card */}
          <div className="tfp-orders-card">
            <div className="tfp-orders-table-wrapper">
              <table className="tfp-orders-table">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Customer</th>
                    <th>Deal Items</th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOrders.length === 0 ? (
                    <tr className="tfp-empty-row">
                      <td colSpan={7}>No orders found.</td>
                    </tr>
                  ) : (
                    filteredOrders.map((order) => (
                      <tr key={order.id}>
                        {/* Order ID */}
                        <td>
                          <span className="tfp-cell-order-id">{order.id}</span>
                        </td>

                        {/* Customer */}
                        <td className="tfp-cell-customer">
                          {order.tpcustomer?.fullname}
                        </td>

                        {/* Deal Items */}
                        <td>
                          <div className="tfp-deal-tags">
                            {order.tpcarts?.map((cart) => (
                              <span key={cart.id} className="tfp-deal-tag">
                                {cart.tpdeal?.deal_title}
                              </span>
                            ))}
                          </div>
                        </td>

                        {/* Amount */}
                        <td className="tfp-cell-amount">
                          PKR {order.amount ? order.amount.toLocaleString() : 0}
                        </td>

                        {/* Date */}
                        <td>
                          {new Date(order.created_at).toLocaleString("en-US", {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                          })}
                        </td>

                        {/* Status */}
                        <td>
                          <StatusBadge status={order.status} />
                        </td>

                        {/* Actions */}
                        <td>
                          {/* View Button */}
                          <button
                            className="tfp-btn-action tfp-btn-view"
                            onClick={() =>
                              navigate("/seller-order-detail", {
                                state: { order },
                              })
                            }
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </Container>
      </div>
    </SellerMasterLayout>
  );
};

export default OrdersInSeller;